export default __webpack_public_path__ + "static/logo-white-71391823a2a5169702610d522b251374.png";